<template>
  <v-list three-line>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title v-if="price.title" v-html="price.title" />
        <v-list-item-subtitle v-if="price.subtitle" v-html="price.subtitle" />
        <v-list-item-subtitle v-if="price.description" v-html="price.description" />
        <v-list-item-subtitle v-if="price.hint" v-html="price.hint" />
        <v-list-item-subtitle v-if="showPrice">
          <b> {{ $t(price.prefix) + " " + price.totalAmountAsString }}</b>
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-radio :value="product.years"></v-radio>
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>

<script lang="ts">
import { IPriceConfig } from "@/store/models/thg/active-price";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class ThgProductsPriceCard extends Vue {
  @Prop({ default: false })
  showPrice!: boolean;

  @Prop()
  product!: {
    years: number[];
    title: {
      token: string;
      values: {
        year: number;
      };
    };
    prices: [IPriceConfig];
  };

  get price() {
    return this.product.prices[0];
  }
}
</script>

<style scoped>
.center {
  text-align: center;
}
</style>
